module.exports = __webpack_public_path__ + "static/img/数据采集与清洗.2a5749e7.png";